import React from "react";
import { loginBackground } from "../../Themes/Images";
import classes from './LoginWrapper.module.css'

function LoginWrapper({ img, children, style }) {
  return (
    <div
      style={{
        backgroundImage: `url(${img})`,
        ...style
      }}
      className={classes.container}
    >
      {children}
    </div>
  );
}

LoginWrapper.defaultProps = {
  img: loginBackground,
};

export default LoginWrapper;
